import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import substackPosts from './posts/posts-list.json';
import '../Medium/Medium.css';

const Substack = () => {
  return (
    <>
      <Helmet>
        <title>The Cybersecurity Newsletter - Weekly Security Intelligence | Victor Barbarosh</title>
        <meta name="description" content="The Cybersecurity Newsletter - Your Monday cybersec intelligence briefing. Weekly digest covering critical vulnerabilities, threat intelligence, and security best practices." />
        <meta name="keywords" content="cybersecurity newsletter, security intelligence, vulnerability alerts, threat intelligence, CVE, security digest, infosec" />
        <meta property="og:title" content="The Cybersecurity Newsletter - Weekly Security Intelligence" />
        <meta property="og:description" content="Your Monday cybersec intelligence briefing. Weekly digest covering critical vulnerabilities and threat intelligence." />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="platform-page">
        <Link to="/" className="home-link top">
          <img src="/portfolio/assets/images/victor-barbarosh-profile.png" alt="Home" className="home-icon" />
          Home
        </Link>

        <header className="platform-header">
          <div className="platform-title-row">
            <img src="/portfolio/assets/images/substack-logo.svg" alt="Substack - The Cybersecurity Newsletter platform" className="platform-logo" />
            <h1>The Cybersecurity Newsletter</h1>
          </div>
          <p className="platform-description">Your Monday cybersec intelligence briefing</p>
        </header>

        <div className="posts-grid">
          {substackPosts.map((post) => (
            <article key={post.id} className="post-card">
              <div className="post-meta">
                <span className="category-badge technical">Security Digest</span>
                <time dateTime={post.datePublished}>{new Date(post.datePublished).toLocaleDateString()}</time>
              </div>
              <div className="post-title-row">
                <img src="/portfolio/assets/images/cybersecurity-newsletter-logo.png" alt="The Cybersecurity Newsletter - Weekly security intelligence briefing" className="post-thumbnail" />
                <h2>{post.title}</h2>
              </div>
              <p className="post-summary">{post.briefSummary}</p>
              <div className="post-actions">
                {post.content ? (
                  <Link to={`/substack/${post.id}`} className="read-more-btn">
                    Read Post
                  </Link>
                ) : (
                  <a href={post.externalLink} target="_blank" rel="noopener noreferrer" className="external-link-btn">
                    Read on Substack
                  </a>
                )}
              </div>
            </article>
          ))}
        </div>

        <Link to="/" className="home-link bottom">
          <img src="/portfolio/assets/images/victor-barbarosh-profile.png" alt="Home" className="home-icon" />
          Home
        </Link>
      </div>
    </>
  );
};

export default Substack;
